module.exports = __webpack_public_path__ + "img/Seminario_Sarvangasana.d847bf8f.png";